import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[tidyReplaceEnterToBlur]',
    standalone: false
})
export class ReplaceEnterToBlurDirective {

  @Input() replaceEnterToBlur: string;

  constructor(
    private el: ElementRef
    ) {}

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    if ((event.which === 13 || event.keyCode === 13)) {
      this.el.nativeElement.focus();
      this.el.nativeElement.blur();
    }
  }
}
